export enum BannerDefault {
  SQOALUrl = 'https://www.myidtravel.com/myidtravel/ui/',
  Currency = 'SGD'
}